export const NUMBER_PICKER_TEST_ID = {
  value: 'number-picker-value',
  increment: 'number-picker-increment',
  decrement: 'number-picker-decrement',
};
